export enum NotificationBadgeType {
  TAG = "tag",
  DEFAULT = "default",
}
